export type Faq = {
  question: string;
  answer: string;
};

export const faqs: Faq[] = [
  {
    question: 'What does Atlas AG build?',
    answer:
      'Atlas AG builds custom operational software for businesses whose real workflow does not fit an off-the-shelf tool. That includes scheduling, field operations, quoting, compliance, customer portals, tracking, internal systems, and native mobile applications for iOS and Android. The work starts with the operational problem, then turns it into a product people can actually use.',
  },
  {
    question: 'Do you build mobile apps?',
    answer:
      'Yes. Atlas AG builds native mobile applications for iOS and Android when the work happens away from a desk, including tap to pay on the phone for in-person card payments. App Store submission and review are handled as part of the engagement. Mobile work is scoped and priced to its size and requirements the same way as platform work, with a fixed scope, price, and date agreed before work starts.',
  },
  {
    question: 'Do you build booking or service request pages?',
    answer:
      'Yes. Atlas AG builds service request pages with a short, phone-friendly form, a clear next step, and a personal status link so customers can follow a job through to done. The request system connects to your existing site rather than replacing it: use a page on your own subdomain or have your developer connect their own form. Owners receive complete requests in email and a web inbox, can move jobs forward, and receive deposits directly in their own Stripe account. Setup is $1,200, then $99 monthly (or $990 prepaid annually). Each page can describe the business and its booking process in a machine-readable format and provide a secure way for an AI assistant to submit a request when asked. An assistant cannot charge a customer; any deposit requires the customer’s own approval. Some people are beginning to ask AI assistants to find and book local services; the assistant submission path is for requests made at a customer’s direction.',
  },
  {
    question: 'How long does a custom software build take?',
    answer:
      'Most Atlas AG custom software builds go live in six to ten weeks. Timing depends on how many workflows, roles, integrations, and data migrations the first version needs. The goal is a useful production release, not a long discovery project.',
  },
  {
    question: 'How much does custom software cost?',
    answer:
      'Paid discovery is $3,500 for two weeks, producing a spec, wireframes, and a fixed quote, and is credited against the build. Custom builds start at $15,000. A focused single-workflow tool typically runs $15,000 to $25,000. A multi-role operational platform with roles, notifications, payments, and mobile typically runs $35,000 to $60,000. A product you intend to sell as SaaS starts around $60,000. Scope and integrations determine where a project lands in those ranges. Atlas AG uses fixed scope, fixed price, and fixed date rather than open-ended hourly billing.',
  },
  {
    question: 'Who owns the software when it is finished?',
    answer:
      'When a build is finished, the client owns the code, database, and customer data. Atlas AG hands over the deployed software and documentation rather than trapping the operation in a per-seat platform. Ongoing support is optional, not a condition of ownership.',
  },
  {
    question: 'Do you host the software after it launches?',
    answer:
      'By default, finished software is deployed to infrastructure the client owns—that is what makes ownership real. Atlas AG Managed, including hosting, monitoring, updates, and support, is available as a separate monthly service for clients who would rather not run it themselves. The client chooses the operating model; managed service is not the default.',
  },
  {
    question: 'Who pays for third-party services like AI, SMS, and email?',
    answer:
      'The client pays for the third-party services their software uses, such as AI APIs, SMS, email, mapping, or payment processing. Those accounts and usage costs remain visible instead of being hidden inside an opaque software fee. Atlas AG helps select and connect the services, then the client keeps control of the accounts.',
  },
  {
    question: 'What industries do you work with?',
    answer:
      'Atlas AG works with field-based and operational businesses in construction, agriculture, landscaping, logging, municipal operations, and the trades. The studio also builds for regulated professional services and local businesses when the workflow is specific enough to need custom software. The common thread is operational work that off-the-shelf software does not fit.',
  },
  {
    question: 'Do you take on small marketing site projects?',
    answer:
      'Atlas AG takes on marketing and brochure sites when capacity allows. They are billed hourly at $225 with a not-to-exceed cap quoted up front, plus $50 per month for hosting. Once a project needs user accounts, a customer portal, or an admin dashboard, it becomes a platform build starting at $15,000.',
  },
];

export type ServiceArea = {
  schemaType: 'AdministrativeArea' | 'State' | 'Country';
  name: string;
  description?: string;
};

export const serviceAreas: ServiceArea[] = [
  { schemaType: 'AdministrativeArea', name: 'Boise metropolitan area' },
  { schemaType: 'AdministrativeArea', name: 'Treasure Valley' },
  { schemaType: 'State', name: 'Idaho' },
  {
    schemaType: 'Country',
    name: 'United States',
    description: 'Remote work available nationally.',
  },
];